import React, { useState, useContext, useEffect } from "react";
import { Box, Typography, Button, Paper, Checkbox } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Grid from '@mui/material/Grid2';


import Stack from "@mui/material/Stack";
import GeneralContext from "../GeneralContext/GeneralContext";
import InputFilter from "../GeneralComponents/InputFilter";
import InputChipSelect from "../GeneralComponents/InputChipSelect";
import axios from "../../api/axios";
import {toSnakeCase} from "../utils/general_utils";

import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import ListStepper from "../GeneralComponents/ListStepper";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import ListEmpty from "../GeneralComponents/ListEmpty";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { CircularProgress } from '@mui/material';
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import ModalStandardCancel from "../GeneralComponents/ModalStandardCancel";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import IconButton from "@mui/material/IconButton";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { alpha } from "@mui/material/styles";
import IndicadorCumplimiento from "../GeneralComponents/IndicadorCumplimiento";
import {
  ROLES_CUMPLIMIENTO,
  CUMPLE,
  NO_CUMPLE,
  SIN_DATOS,
  evaluarCumplimiento,
  datosCierre,
  ordenarFilas,
  columnasExcelDocumento,
  filaExcelDocumento,
  exportarExcel,
} from "../utils/documentos_utils";


import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {NO_EES, NO_EES_TEMP, NO_SUBTEL, REJECTED, APROVED, NO_MINEDUC, ROL_ADMIN, ROL_OP_ADMIN, ROL_OP_INS, ROL_REP_EES, ROL_REP_EES_TEMP, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";


let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);

const columns = [
  {
    id: "checkbox",
    label: "",
    width: "5%",
    minWidth: "50px",
    align: "center",
  },

  { id: "rbd", label: "RBD", width: "5%", minWidth: "80px", sortable: true, sortType: "number" },
{ id: "folio", label: "ID folio", width: "12%", minWidth: "80px", sortable: true },
  { id: "fecha", label: "Fecha", width: "12%", minWidth: "120px", sortable: true, sortKey: "fecha_creacion" },
  { id: "rut_instalador", label: "Run Instalador", width: "12%", minWidth: "120px", sortable: true },
  {
    id: "estado_resumen",
    label: "Estado",
    width: "16%",
    minWidth: "160px",
    align: "left",
    sortable: true,
  },
  {
    id: "cumplimiento",
    label: "Cumple lo pactado",
    width: "12%",
    minWidth: "140px",
    align: "left",
    sortable: true,
  },
  {
    id: "firma",
    label: "Firma",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "detalle",
    label: "Detalle Documento",
    width: "12%",
    minWidth: "80px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "temporal",
    label: "Representante Temporal",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
    sortable: true,
  },
  {
    id: "revisar",
    label: "Revisar documento",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "revisar_no_sub",
    label: "Revisar documento",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "url",
    label: "Descarga PDF",
    width: "10%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "operador",
    label: "Operador",
    width: "12%",
    minWidth: "100px",
    align: "left",
    sortable: true,
  },
  {
    id: "reject",
    label: "Anular",
    width: "12%",
    minWidth: "50px",
    align: "center",
  },
];




export default function FusList() {
  const [rows, setRows] = useState([]);
  const { includeRol, pageTitle, setPageTitle, userSesion } = useContext(GeneralContext);
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState(rows);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [selected, setSelected] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [techTypes, setTechTypes] = useState([]);
  const [orderBy, setOrderBy] = useState(null);
  const [order, setOrder] = useState("asc");

  const navigate = useNavigate();
  const verCumplimiento = includeRol(ROLES_CUMPLIMIENTO);

  const sortedData = React.useMemo(
    () => ordenarFilas(tableData, columns, orderBy, order),
    [tableData, orderBy, order]
  );

  const handleSort = (columnId) => {
    setPage(0);
    if (orderBy !== columnId) {
      setOrderBy(columnId);
      setOrder("asc");
    } else {
      setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    }
  };

  const firmasPendientes = [ NO_EES, NO_EES_TEMP, NO_SUBTEL, NO_MINEDUC ];

  const rolesFirma = {
    EES: [ NO_EES, NO_EES_TEMP ],
    SUBTEL: [ NO_SUBTEL ],
    MINEDUC: [ NO_MINEDUC ],
  };



const downloadXLS = () => {
  if (tableData.length === 0) {
    alert("No hay filas seleccionadas para descargar.");
    return;
  }


  const filas = sortedData.map((row) => {
    const pactado = row.datos?.validation_data ?? {};
    const techId = row.datos?.tech_id ?? pactado.tech_id;
    const tech = techTypes.find((t) => t.id_tipo_tecnologia === techId);
    return filaExcelDocumento(row, {
      id: row.fus_id,
      tipoTecnologia: tech?.nombre_enlace,
      pactado,
    });
  });

  exportarExcel({
    nombreArchivo: "fus_seleccion.xlsx",
    nombreHoja: "FUS",
    columnas: columnasExcelDocumento("fus", verCumplimiento),
    filas,
  });
};



function getSignatureText(currentState) {

    let inst = "FAS";
    if (includeRol([ROL_REP_EES, ROL_REP_EES_TEMP])) {
        inst = "EES";
    } else if (includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL])) {
        inst = "SUBTEL";
    } else if (includeRol([ROL_MINEDUC_ADMIN, ROL_CON_MINEDUC])) {
        inst = "MINEDUC";
    }

    const currentStep = firmasPendientes.indexOf(currentState);

    const userSteps = rolesFirma[inst] || [];

    const userStepsIndex = firmasPendientes.findIndex((etapa) =>
        userSteps.includes(etapa)
    );
    if (userSteps.includes(currentState)) {
        return "Firmar";
    }

    if (userStepsIndex > currentStep) {
        return "Firmar";
    }
    return "Firmado";
}

  const canSign = (estado) => {
    if (
      (estado === NO_EES || estado === NO_EES_TEMP) &&
      includeRol([ROL_REP_EES, ROL_REP_EES_TEMP])
    ) {
      return true;
    } else if (
      (estado === NO_EES || estado === NO_EES_TEMP) &&
      includeRol([ROL_MINEDUC_ADMIN])
    ) {
      return true;
    } else if (
      estado === NO_SUBTEL &&
      includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL])
    ) {
      return true;
    } else if (
      estado === NO_MINEDUC &&
      includeRol([ROL_MINEDUC_ADMIN, ROL_CON_MINEDUC])
    ) {
      return true;
    }

    return false;
  };

  const rejectOperador = async () => {
  if (!currentRow ) return;
  console.log(currentRow);
  setLoading(true);
  axios.rejectDocOperador("fus", currentRow.fus_id)
      .then((response) => {
        fetchData();
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });

    setOpenVerify(false);
};

  const [currentRow, setCurrentRow] = React.useState(null);
  const [verifyMsg, setVerifyMsg] = React.useState("");
  const [openVerify, setOpenVerify] = React.useState(false);
  const handleOpenVerify = (row) => {setCurrentRow(row); setVerifyMsg(`¿Está seguro que desea anular el FUS con folio ${String(row.fus_id).padStart(8, "0")} para el RBD ${row.rbd}?`); setOpenVerify(true);}
  const handleCloseVerify = () =>{ setOpenVerify(false); }

    const downloadPDF = (url) => {
      setLoadingPDF(true);
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');

                a.href = blobUrl;
                a.download = 'download.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch((error) => {setLoadingPDF(false); console.error('Error al descargar el archivo:', error); window.open(url, '_blank'); });
    };

    const downloadZip = async () => {
      try {
        if (selected.length === 0){
          return
        }
        setDownloadLoader(true);
        const now = new Date();
        const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(now.getSeconds()).padStart(2, "0")}`;
        
        const response = await axios.downloadDocuments("fus", selected);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `fus_${timestamp}.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (error) {
        console.error("Error al descargar documentos:", error);
    }
    setDownloadLoader(false);
  };


  const fetchData = async () => {
    setLoading(true);
      axios.getFusList(userSesion.id)
      .then((response) => {
        const modifiedData = response.data.data.map((row) => {
          const nombres = row.datos?.ees_temporal_manager_nombres ?? "";
          const apellidos = row.datos?.ees_temporal_manager_apellidos ?? "";

          const nombreCompleto = `${nombres} ${apellidos}`.trim();
          return {
            ...row,
            ...datosCierre(row),
            ...evaluarCumplimiento(row.datos, row.datos?.validation_data),
            fecha: row.fecha_creacion.split("T")[0],
            periodo: row.fecha_creacion.slice(0, 7),
            rut_instalador: row.datos["rut"],
            estado_resumen:
              row.estado !== APROVED && row.estado !== REJECTED
                ? "En Proceso"
                : row.estado,
              puede_firmar: canSign(row.estado),
              operador: row.datos['operator_name'],
              temporal: nombreCompleto !== "" ? nombreCompleto : " Sin Representante Temporal",
              firma: "",
              checkbox: "",
              detalle: "",
              revisar: "",
              revisar_no_sub: "",
              folio: String(row.fus_id).padStart(8, "0"),

          };
        });
        setRows(modifiedData);
        setTableData(modifiedData);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });

    if (
      includeRol([ROL_REP_EES, ROL_REP_EES_TEMP])
    ) {
      const columnOrder = [
            "checkbox",
            "operador",
            "folio",
            "fecha",
            "rut_instalador",
            "temporal",
            "estado_resumen",
            "revisar_no_sub",
            "url",
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter((column) => column && (column.id !== "cumplimiento" || verCumplimiento))
    );
    } else if (includeRol([ROL_ADMIN, ROL_MINEDUC_ADMIN])) {
     const columnOrder = [
            "checkbox",
            "operador",
            "folio",
            "rbd",
            "fecha",
            "rut_instalador",
            "temporal",
            "estado_resumen",
            "cumplimiento",
            "revisar_no_sub",
            "url",
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter((column) => column && (column.id !== "cumplimiento" || verCumplimiento))
    );
        }else if (includeRol([ROL_VAL_SUBTEL, ROL_ADMIN_SUBTEL])) {
     const columnOrder = [
            "checkbox",
            "operador",
            "folio",
            "rbd",
            "fecha",
            "rut_instalador",
            "estado_resumen",
            "cumplimiento",
            "revisar",
            "url",
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter((column) => column && (column.id !== "cumplimiento" || verCumplimiento))
    );
        } else if( includeRol([ROL_OP_ADMIN])){
     const columnOrder = [
            "checkbox",
            "operador",
            "folio",
            "fecha",
            "rut_instalador",
            "estado_resumen",
            "revisar_no_sub",
            "url",
            "reject",
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter((column) => column && (column.id !== "cumplimiento" || verCumplimiento))
    );

    } else if( includeRol([ROL_OP_INS])){
     const columnOrder = [
            "folio",
            "rbd",
            "fecha",
            "rut_instalador",
            "estado_resumen",
            "detalle",
            "firma",
            "reject",
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter((column) => column && (column.id !== "cumplimiento" || verCumplimiento))
    );

    }
  };

    const handleSelectAll = (event) => {
  if (event.target.checked) {
    const newSelecteds = sortedData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((n) => n.fus_id);
    setSelected(newSelecteds);
  } else {
    setSelected([]);
  }
};

  const handleCheckboxClick = (index) => {
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (index) => selected.indexOf(index) !== -1;


  useEffect(() => {
    fetchData();
    axios.getTechTypes()
      .then((response) => setTechTypes(response.data ?? []))
      .catch(() => {});
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

const filterRecords = (name: string, value: any) => {
  const filterObj = { ...filters };
  filterObj[name] = value;

  // Eliminar del objeto si el filtro está vacío
  const isEmpty =
    value === null ||
    (Array.isArray(value) && value.length === 0);

  if (isEmpty) {
    delete filterObj[name];
  }


  const newTableData =
    Object.keys(filterObj).length !== 0
      ? rows.filter((item) =>
          Object.entries(filterObj).every(([key, val]) => {

            if ((key === "folio" || key === "rbd") && Array.isArray(val)) {
              if(key === "folio"){
                return val.includes(item.folio);
              } else {
                return val.includes(item.rbd);
              }
              
            }

            return item[key] === val;
          })
        )
      : rows;

  if (JSON.stringify(newTableData) !== JSON.stringify(tableData)) {
    setSelected([]);
  }

  const maxPage = Math.floor((newTableData.length - 1) / rowsPerPage);
  if (page > maxPage) {
    setPage(0);
  }

  setFilters(filterObj);
  setTableData(newTableData);
};


  useEffect(() => {
    setPageTitle("Listado de FUS");
  }, [pageTitle, setPageTitle]);

    function transformData(data) {
  const ROLES = ["MINEDUC", "SUBTEL", "EES"];

  // Asegurar que siempre sea un array simple
  let rawFirmas = data.firmas;
  if (Array.isArray(rawFirmas) && rawFirmas.length === 1 && Array.isArray(rawFirmas[0])) {
    rawFirmas = rawFirmas[0];
  }

  const firmas = Array.isArray(rawFirmas) ? rawFirmas : [];

  const steps = firmas.map((firma) => {
    const rolStr = typeof firma.rol_firma === "string" ? firma.rol_firma : "";
    const inst = ROLES.find((r) => rolStr.includes(r)) || "FUS";

    const nombreBase = firma.nombre_firma ?? firma.nombre ?? "";
    const apellido = firma.apellidos_firma ?? "";
    const fullName = apellido ? `${nombreBase} ${apellido}` : nombreBase;

    return {
      type: firma.estado_firma,
      institution: {
        type: inst,
        name: inst,
        rol_firma: firma.rol_firma,
      },
      in_charge: [fullName],
    };
  });

  return {
    ...data,
    firmas: firmas,
    progress: {
      state: data.estado,
      steps,
    },
  };
}

  function Row(props) {
    const { row, index } = props;
  const [open, setOpen] = React.useState(false);
  const [firmasRow, setFirmasRow] = React.useState(row.firmas || []);
  const [loadingFirmas, setLoadingFirmas] = React.useState(false);

  const isItemSelected = isSelected(row.fus_id);

  const handleToggle = async () => {
    setOpen((prev) => !prev);

    if (!open && (!firmasRow || firmasRow.length === 0)) {
      setLoadingFirmas(true);
      try {
        const response = await axios.getFusFirma(row.fus_id);
        const newFirmas = response.data || [];

        row.firmas = newFirmas;
        setFirmasRow(newFirmas);
      } catch (error) {
        console.error("Error al obtener firmas:", error);
      } finally {
        setLoadingFirmas(false);
      }
    }
  };

  const transformedRow = React.useMemo(() => {
    return transformData({ ...row, firmas: firmasRow });
  }, [row, firmasRow]);


    return (
      <React.Fragment>
        <TableRow onClick={() => handleToggle()} 
          hover
          test_state={row.estado}  test_data={row.fus_id}
          role="checkbox"
          tabIndex={-1}
          id={row.fus_id}
          key={"TR_" + row.fus_id}
          style={{ paddingBottom: 0, paddingTop: 0 }}
        >
          {filteredColumns.map((column, index) => {
            const value = row[column.id];
            return (
              <TableCell key={"TC" + index} align={column.align}>
                {column.id === "url" ? (
                  <Button
                  disabled={loadingPDF }
                    onClick={(e) => { e.stopPropagation();
                      downloadPDF(value)
                    }}
                    key={`${column.id}.button.${index}`}
                    variant="text"
                    startIcon={
                      <PictureAsPdfIcon
                        key={`${column.id}.icon.${index}`}
                        sx={{ color: loadingPDF  ? "grey" : "#111" }}
                      />
                    }
                  >
                    <Stack>
                      <Typography
                        key={`${column.id}.typ.${index}`}
                        sx={{
                          color: loadingPDF ? "grey" : "#111",
                          textTransform: "capitalize",
                          textDecoration: "underline",
                        }}
                      >
                        Descargar
                      </Typography>
                    </Stack>
                  </Button>
                ) : column.id==="detalle" ? (
                  <Button
                    onClick={(e) => { 
                      e.stopPropagation();
                      window.open('/fus_detalle/'+row["fus_id"], "_blank");
                    }}
                    key={`${column.id}.button.${index}`}
                    variant="text"
                  >
                    <Typography
                      key={`${column.id}.typ.${index}`}
                      sx={{
                        color: "#111",
                        textTransform: "capitalize",
                        textDecoration: "underline",
                      }}
                    >
                      Ver
                    </Typography>
                  </Button>
                ) : column.id.startsWith("firma") && (row["estado_resumen"] !== REJECTED && row["estado_resumen"] !== APROVED) ? (
                  <PageButtonBlack
                    width="100%"
                    loading={!row["puede_firmar"]}
                    pad="0 1rem"
                    onClick={(e) => { 
                      e.stopPropagation();
                      window.open("/fus_firma/"+row["fus_id"], "_blank");
                    }}
                  >
                    { getSignatureText(row['estado']) }
                  </PageButtonBlack>
                ) : column.id === "checkbox" ? (
                                    <Checkbox
                                      color="primary"
                                      checked={isItemSelected}
                                      onClick={() =>
                                        handleCheckboxClick(row.fus_id)
                                      }
                                      inputProps={{
                                        "aria-labelledby": row.fus_id,
                                      }}
                                    />
                                  ) :

                column.id === 'estado_resumen' ? (
                
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'no-wrap',
                    }}>
                      <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: value === 'En Proceso' ? '#FFE263' : value === APROVED ? '#41AE43' : '#FB3B3B' , marginRight: "0.5rem" }} />

                      {value}
                      <Box sx={{ flexGrow: 1 }} />
                      {value !== 'En Proceso' ? null : open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    </div>

                ) : column.id === "cumplimiento" ? (
                  <IndicadorCumplimiento estado={value} detalle={row.detalle_incumplimiento} />
                ) : column.id === "revisar" ? (
                      <PageButtonWhite 
                        width="100%"
                        pad="0 1rem"
                        onClick={(e) => {
                          e.stopPropagation();

                          const baseUrl =
                            row["estado"] === REJECTED || row["estado"] === APROVED
                              ? "/fus_detalle/"
                              : !row["puede_firmar"]
                                ? "/fus_rechazar/"
                                : "/fus_firma/";

                          window.open(baseUrl + row["fus_id"], "_blank");
                        }}
                      >
                        Entrar
                      </PageButtonWhite>
                    )

                : column.id === "revisar_no_sub" ? (
                      <PageButtonWhite 
                        width="10rem"
                        pad="0 1rem"
                        onClick={(e) => {
                          e.stopPropagation();

                          const baseUrl =
                            row["estado"] === REJECTED || row["estado"] === APROVED
                              ? "/fus_detalle/"
                              : !row["puede_firmar"]
                                ? "/fus_detalle/"
                                : "/fus_firma/";

                          window.open(baseUrl + row["fus_id"], "_blank");
                        }}
                      >
                        Entrar
                      </PageButtonWhite>
                    )
                : column.id === "reject" ? (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <IconButton
      aria-label="anular"
      size="large"
      disabled={!(row["estado"] === NO_EES || row["estado"] === NO_EES_TEMP)}
      onClick={(e) => {
        e.stopPropagation();
        handleOpenVerify(row);
      }}
      sx={{
        borderRadius: "50%",
        p: 0.75,
        color: (t) =>
          !(row["estado"] === NO_EES || row["estado"] === NO_EES_TEMP) ? t.palette.action.disabled : t.palette.error.main,
        "&:hover": (t) => ({
          backgroundColor: alpha(t.palette.error.main, 0.12),
        }),
      }}
    >
      <DeleteForeverOutlinedIcon />
    </IconButton>
  </Box>
) :
                 (
                  value
                )}
              </TableCell>
            );
          })}
        </TableRow>
        {row["estado_resumen"] === "En Proceso" ? (
          <TableRow key={row.code + 1}>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                 {loadingFirmas ? (
                  <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px',
                height: '20vh',
                width: '100%',
                backgroundColor: 'white'
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando Firmas...
              </Typography>
            </Box>
                ) : (
                  <ListStepper
                    row={transformedRow}
                    source="FUS"
                    formData={row}
                  />
                )}
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }

  return (
    <PageBody>
      <Box width="100%">
         <Grid
  container
  spacing={1}
  sx={{ marginBottom: "28px", marginTop: "-2rem" }}
  alignItems="flex-start" // <- evita que los elementos se estiren en vertical
>
  {/* Filtros agrupados */}
  <Grid size={6}>
    <Grid container spacing={1}>

      {includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_REP_EES,
        ROL_REP_EES_TEMP,
        ROL_CON_MINEDUC,
        ROL_VAL_SUBTEL,
        ROL_ADMIN,
        ROL_ADMIN_SUBTEL
      ]) && (
        <Grid size={6}>
          <InputFilter
            data={rows}
            item={"operador"}
            name={"Operador"}
            callback={filterRecords}
          />
        </Grid>
      )}


     
        <Grid size={6}>
          <InputFilter
            data={rows}
            item={"fecha"}
            name={"Fecha"}
            callback={filterRecords}
            sortDesc
          />
        </Grid>
    


      <Grid size={6}>
        <InputFilter
          data={rows}
          item={"estado"}
          name={"Estado"}
          defaultOpt={['Aprobado', 'Falta Firma EES', 'Falta Firma EES Temporal', 'Falta firma SUBTEL', 'Falta firma MINEDUC', 'Rechazado']}
          callback={filterRecords}
        />
      </Grid>

      <Grid size={6}>
        <InputFilter
          data={rows}
          item={"rut_instalador"}
          name={"RUN Instalador"}
          callback={filterRecords}
        />
      </Grid>

              { includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_CON_MINEDUC,
        ROL_ADMIN
      ]) && ( <Grid size={6}>
        <InputFilter
          data={rows}
          item={"temporal"}
          name={"Representante Temporal"}
          callback={filterRecords}
        />
      </Grid>
    )
  }

      {verCumplimiento && (
        <Grid size={6}>
          <InputFilter
            data={rows}
            item={"cumplimiento"}
            name={"Cumplimiento de lo pactado"}
            defaultOpt={[CUMPLE, NO_CUMPLE, SIN_DATOS]}
            callback={filterRecords}
          />
        </Grid>
      )}
    </Grid>
  </Grid>

  {/* InputChipSelect independiente */}
  <Grid container size={6} spacing={0}>
  <Grid size={12} >
    <InputChipSelect
      data={rows}
      item={"folio"}
      name={"ID folio"}
      callback={filterRecords}
    />

  </Grid>

  { includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_CON_MINEDUC,
        ROL_VAL_SUBTEL,
        ROL_ADMIN
      ]) && (<Grid size={12}>
    <InputChipSelect
      data={rows}
      item={"rbd"}
      name={"RBD"}
      callback={filterRecords}
    />
  </Grid>)


  }
    
  </Grid>

</Grid>

        <Paper
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            background: "#FFFFFF",
            borderRadius: "0.25rem",
            marginBottom: "0.75rem",
          }}
        >
          <Typography
            variant="h1"
            color="inherit"
            noWrap
            sx={{ textAlign: "center", padding: "0.5rem" }}
          >
            LISTADO FUS
          </Typography>
        </Paper>


        {loading?
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                width: '100%',
                backgroundColor: 'white'
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando...
              </Typography>
            </Box>
            :
            <>
        <PageBgBlock pad="0">
          <Paper
            sx={{
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
              background: "#FFFFFF",
              borderRadius: "0.25rem",
              marginBottom: "0.75rem",
            }}
          >
            <TableContainer>
              <Table size="small" aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {filteredColumns.map((column, index) => (
                      <TableCell
                        key={"CL" + index}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        sortDirection={orderBy === column.id ? order : false}
                      >
                        {column.id === "checkbox" ? (
                            <Box display="flex" alignItems="center">
                              <Checkbox
                                color="primary"
                                indeterminate={
                                  selected.length > 0
                                }
                                checked={
                                  selected.length > 0 
                                }
                                onChange={handleSelectAll}

                                inputProps={{ "aria-label": "select all" }}
                              />

                              {column.label}
                            </Box>
                          ) : column.sortable ? (
                            <TableSortLabel
                              active={orderBy === column.id}
                              direction={orderBy === column.id ? order : "asc"}
                              onClick={() => handleSort(column.id)}
                            >
                              {column.label}
                            </TableSortLabel>
                          ) : (
                            column.label
                          )}

                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <Row key={index} row={row} index={index} />
                    ))}

                </TableBody>
              </Table>
                {tableData.length === 0 ? (<ListEmpty></ListEmpty>) : null}
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={tableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </PageBgBlock>

        {!includeRol([ROL_OP_INS]) ? (
          <Grid container spacing={2} sx={{display: "flex"}}>
          <Grid size={4}>
           
          </Grid>

          <Grid size={4}>
      <PageButtonWhite
        loading={tableData.length === 0}
        onClick={downloadXLS}
        width="100%"
      >
        Descarga .xlsx filtrados ({tableData.length || "0"})
      </PageButtonWhite>
    </Grid>

          <Grid size={4}>
            <PageButtonWhite
              loading={downloadLoader || selected.length === 0}
              onClick={downloadZip}
              width="100%"
            >
              Descarga selección de documentos (.zip)
            </PageButtonWhite>
          </Grid>
          </Grid>) : null }
          </>

          }
       
      </Box>
      <ModalStandardCancel
        open={openVerify}
        error={true}
        icon={<CancelOutlinedIcon color="error" sx={{ fontSize: 55 }}/>}
        title="Anular FUS"
        qst={verifyMsg}
        msg="Esta acción solo puede ser realizada si no existen firmas posteriores a la creación del documento."
        btnText="OK, anular FUS"
        onClick={rejectOperador}
        onClose={handleCloseVerify}
      />
    </PageBody>
  );
}
